<div id="simple-map"></div>
<div #rotatingMarker class="rotatingMarker" *ngIf="currentRotation">
    <img  src="assets/images/remotes/iconmarkeruser.png" />
</div>